// extracted by extract-css-chunks-webpack-plugin
module.exports = {"editButton":"ProfileSummaryButton__editButton--1daey"};